import { Component, OnInit, Input, Optional, Self, ElementRef, ViewChild } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { CreditCardModel } from '../../models/credit-card.model';



@Component({
  selector: 'intelli-credit-card-editor',
  templateUrl: './intelli-credit-card-editor.component.html',
  styleUrls: ['./intelli-credit-card-editor.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: IntelliCreditCarcEditorComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliCreditCarcEditorComponent implements MatFormFieldControl<CreditCardModel>, ControlValueAccessor {

  @ViewChild('cardNumber',{static:true}) cardNumber: ElementRef;
  @ViewChild('cardName',{static:true}) cardName: ElementRef;
  @ViewChild('cardExpiry',{static:true}) cardExpiry: ElementRef;
  @ViewChild('cardCvc',{static:true}) cardCvc: ElementRef;

  static nextId = 0;
  mainForm: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'intelli-text-editor';
  id = `intelli-credit-card-editor-${IntelliCreditCarcEditorComponent.nextId++}`;
  describedBy = '';
  private onChangeValue: (value: CreditCardModel) => void;
  _value: CreditCardModel;

  constructor(@Optional() @Self() public ngControl: NgControl,
    private _formBuilder: UntypedFormBuilder, private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.updateGui();

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });


    // this.InitializeAutocompleteControls();
  }



  writeValue(obj: CreditCardModel): void {


    this.value = obj;
  }
  registerOnChange(onChange: (value: CreditCardModel) => void): void {

 
    this.onChangeValue = onChange;


  
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.mainForm.get("textControlName").disable();
    }
    else {
      this.mainForm.get("textControlName").enable();
    }
  }


  get empty() {
    
 
    return false;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);

    // if (this._disabled)
    //   this.mainForm.get("textControlName").disable()
    // else
    //   this.mainForm.get("textControlName").enable()

    // this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): CreditCardModel | null {

    return this._value;

  }

  set value(value: CreditCardModel | null) {

    this._value = value;
    

    this.updateGui();

    setTimeout(() => {
      let event = new KeyboardEvent('keyup',{  "code": "5"});

      this.cardNumber.nativeElement.dispatchEvent(event);
      this.cardName.nativeElement.dispatchEvent(event);
      this.cardExpiry.nativeElement.dispatchEvent(event);
      this.cardCvc.nativeElement.dispatchEvent(event);

    }, (1));




    
    this.stateChanges.next();
  }



  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {

  }

 public updateGui(): any {

console.log("update gui")
   if(this._value == null)
   {
     this._value =  new CreditCardModel();
   }

    this.mainForm = this._formBuilder.group(this._value);


    this.mainForm
      .valueChanges
      .subscribe(() => {

    

        this.propagateChanges();
      }
      );

    //  this.testeccc();
  }

  public propagateChanges() {
    this._value = this.mainForm.value;
    this._value.isValid = true;

    if (! /^[0-9\s]+$/.test(this._value.number )) {
      // Validation failed
      this._value.isValid = false;
    }

    if (! /^[0-9]+$/.test(this._value.cvc.toString() )) {
      // Validation failed
      this._value.isValid = false;
    }


    if (! /^[0-9\/\s]+$/.test(this._value.expiry.toString() )) {
      // Validation failed
      this._value.isValid = false;
    }

    if (this._value.number.length < 16) {
      // Validation failed
      this._value.isValid = false;
    }


    console.log(this._value);


    if (this.onChangeValue != null) {

      console.log("mudou valor")
      this.onChangeValue(  this.value)
    }
  }

}